import { render, staticRenderFns } from "./voteResult.vue?vue&type=template&id=4e75f7b4&scoped=true&"
import script from "./voteResult.vue?vue&type=script&lang=js&"
export * from "./voteResult.vue?vue&type=script&lang=js&"
import style0 from "./voteResult.vue?vue&type=style&index=0&id=4e75f7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e75f7b4",
  null
  
)

export default component.exports